import { ProcessedVehicleInformation, VehicleInformation, VehicleStatus, Stage } from '../../types'

const ERROR_HAS_APPOINTMENT = `An appointment already exists for this car, check your email for details on how to update your appointment.`
const ERROR_VEHICLE_RECENTLY_PURCHASED = `Unfortunately we can't provide a valuation for this car.`
const ERROR_GENERAL = `Whoops, something went wrong. Please try again later.`

const getVehicleStatus = (vehicleInformation: VehicleInformation): VehicleStatus => {
  const {
    appointmentStatus: { hasFutureAppointmentToday, hasFutureAppointmentAfterToday },
    vehicleLabelValueLists,
    vehicleRecentlyPurchased,
  } = vehicleInformation

  const hasAppointment = hasFutureAppointmentToday || hasFutureAppointmentAfterToday
  const isNotFoundOrManualLookup = vehicleLabelValueLists.length === 0
  const isMulticar = vehicleLabelValueLists && vehicleLabelValueLists.length > 1

  return {
    isRecentlyPurchased: vehicleRecentlyPurchased,
    hasAppointment,
    isNotFoundOrManualLookup,
    isMulticar,
  }
}

export default (vehicleInformation: VehicleInformation): Promise<ProcessedVehicleInformation> => {
  if (!vehicleInformation) {
    throw new Error(ERROR_GENERAL)
  }

  const { isRecentlyPurchased, hasAppointment, isNotFoundOrManualLookup, isMulticar } = getVehicleStatus(
    vehicleInformation,
  )

  if (isRecentlyPurchased) {
    // todo: build CannotProvideValuation page
    throw new Error(ERROR_VEHICLE_RECENTLY_PURCHASED)
  }

  if (hasAppointment) {
    // todo: build appointmentManage flow
    throw new Error(ERROR_HAS_APPOINTMENT)
  }

  if (isNotFoundOrManualLookup) {
    return Promise.resolve({ vehicleInformation, stage: Stage.VehicleRegistrationCheck })
  }

  if (isMulticar) {
    return Promise.resolve({ vehicleInformation, stage: Stage.VehicleMulticar })
  }

  return Promise.resolve({ vehicleInformation, stage: Stage.VehicleQuestions })
}
